<template>
	<div class="c-page404">
		<h1>404 page not found</h1>
		<router-link to="/" class="btn btn-primary btn-box">
			Back to your library
		</router-link>
	</div>
</template>

<script>
export default {
};
</script>

<style lang="scss">
.c-page404 {
	padding-top: 10rem;
	text-align: center;

	h1 {
		font-weight: 600;
		margin-bottom: 2rem;
		font-family: var(--font-family);
	}
}
</style>
